export const RadioCheckedSVG = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 32 32" {...props}>
        <g id="Group_5283" data-name="Group 5283" transform="translate(-107 -485)">
            <g id="Rectangle_656" data-name="Rectangle 656" transform="translate(107 485)" fill="#fff" stroke="#ced4da" strokeWidth="1">
                <rect width="32" height="32" rx="16" stroke="none" />
                <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="none" />
            </g>
            <rect id="Rectangle_656-2" data-name="Rectangle 656" width="22" height="22" rx="11" transform="translate(112 490)" fill="#007aff" />
        </g>
    </svg>
);
